// Local call history - localStorage based (simple & enough for one user).
// Stores last 100 calls keyed by id.

import { create } from 'zustand'

const STORAGE_KEY = 'kaliai_dialer_history'
const MAX_ENTRIES = 100

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch { return [] }
}
function save(list) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ENTRIES))) } catch {}
}

const useHistoryStore = create((set, get) => ({
  calls: load(),

  add: (call) => {
    const newCall = {
      id: 'c-' + Date.now() + '-' + Math.random().toString(36).slice(2, 6),
      startedAt: new Date().toISOString(),
      endedAt: null,
      direction: call.direction || 'out',
      number: call.number || '?',
      status: call.status || 'ringing', // ringing | answered | ended | failed
      durationSec: 0,
      cause: null,
      ...call,
    }
    const next = [newCall, ...get().calls].slice(0, MAX_ENTRIES)
    save(next)
    set({ calls: next })
    return newCall.id
  },

  update: (id, patch) => {
    const next = get().calls.map(c => c.id === id ? { ...c, ...patch } : c)
    save(next)
    set({ calls: next })
  },

  clear: () => {
    save([])
    set({ calls: [] })
  },
}))

export default useHistoryStore
